export default "__VITE_ASSET__CWBNn4ag__"